import { useQuery } from "@tanstack/react-query";

import { listCustomerContext } from "./api";
import { CustomerKnowledgeCard } from "./CustomerKnowledge";
import type { OperationsNavigate } from "./navigation";

/** The team's notes and files for one customer, company-wide or for one tool (ADR-0062). */
export function CustomerContext({
  customerSlug,
  navigate,
  organizationId,
  ready,
  canRead,
  canReadArtifacts = false,
  canWrite,
  canSearch,
  canUploadArtifacts = false,
}: {
  customerSlug: string;
  navigate: OperationsNavigate;
  organizationId: string;
  ready: boolean;
  canRead: boolean;
  canReadArtifacts?: boolean;
  canWrite: boolean;
  canSearch: boolean;
  canUploadArtifacts?: boolean;
}) {
  const context = useQuery({
    queryKey: ["ops", "context", organizationId],
    queryFn: () => listCustomerContext(organizationId),
    enabled: ready && canRead,
  });
  return (
    <CustomerKnowledgeCard
      canReadArtifacts={canReadArtifacts}
      canReadContext={canRead}
      canSearch={canSearch}
      canUploadArtifacts={canUploadArtifacts}
      canWriteContext={canWrite}
      context={context.data ?? null}
      contextError={context.error}
      contextLoading={context.isLoading}
      customerSlug={customerSlug}
      navigate={navigate}
      organizationId={organizationId}
      ready={ready}
    />
  );
}
